import { RestClient } from '@/api/rest-client'
import { PipelinePhase } from '@/api/model/pipeline-phase'
import { Pipeline } from '@/api/model/pipeline'
import { cloneDeep } from 'lodash'

export class PipelinePhaseClient extends RestClient<PipelinePhase> {
    collectionName = 'pipeline_phases'
    parseData = PipelinePhase.fromData

    async create(data: PipelinePhase): Promise<PipelinePhase> {
        const request = cloneDeep<any>(data)

        if (data.pipeline instanceof Pipeline) {
            request.pipeline = data.pipeline.resourceIdentifier
        }

        return super.create(request)
    }

    async update(id: string, data: PipelinePhase): Promise<PipelinePhase> {
        const request = cloneDeep<any>(data)

        if (data.pipeline) {
            delete request.pipeline
        }

        return super.update(id, request)
    }

    protected handleError(error: any) {
        throw error
    }
}
